import * as React from 'react';
import Section from '../Section';
import { useEffect, useState } from 'react';
import cn from 'classnames';
import { AnalyticsEvent, logEvent } from '@weddingspot/ws-analytics';
import { CSNVenueProfileMeetingRooms, SocialTableRoomData, CSNVenueProfile, RoomItemProps } from '@weddingspot/ws-api-client';

export interface FloorPlansData {
    meetingRooms?: CSNVenueProfileMeetingRooms[];
}

interface Props {
    venueId?: number;
    csnVenueData?: FloorPlansData;
    onSectionExpanded: (name: string) => void;
}

const styles = require('./FloorPlans.scss');

const FloorPlans = (props: Props) => {
    const [showSection, setShowSection] = useState(false);
    const [roomsData, setRoomsData] = useState<RoomItemProps[]>();
    const [showAllPlans, setShowAllPlans] = useState(false);

    useEffect(() => {
        const roomsData: RoomItemProps[] = props.csnVenueData?.meetingRooms
            ?.filter((room) => !!room.socialTables)
            .map((room) => ({
                name: room.name,
                socialTables: room.socialTables
        }) as RoomItemProps) || [];

        if (roomsData?.length) {
            setRoomsData(roomsData);
            setShowSection(true);
            logEvent(AnalyticsEvent.EVTNM_SOCIAL_TABLES_FLOOR_PLANS_SECTION, {
                Source: 'Wedding venue profile',
                'Venue ID': props.venueId,
            });
        }
    }, [props.csnVenueData]);

    return showSection ? (
        <>
            <Section
                onSectionExpanded={() => {
                    props.onSectionExpanded('Floor Plans');
                }}
                title='Floor Plans'
                isExpanded={true}
            >
                <div
                    className={cn(styles.wrapper, {
                        [styles.expanded]: showAllPlans,
                        [styles.expandableOnMobile]: roomsData?.length! > 2,
                        [styles.expandableOnDesktop]: roomsData?.length! > 6,
                    })}
                >
                    {roomsData?.map((room, i) => (
                        <div className={styles.room} key={i}>
                            <img src={room.socialTables.basicFloorPlanImageUrlSmall} alt={room.name} />
                            <div className={styles.roomName}>{room.name}</div>
                            <div className={styles.roomHover}>
                                {room.socialTables.basicFloorPlanPdfUrl && (
                                    <a
                                        href={room.socialTables.basicFloorPlanPdfUrl}
                                        className='nx-button nx-button--primary'
                                        onClick={() => {
                                            logEvent(AnalyticsEvent.EVTNM_FLOOR_PLANS_DOWNLOAD, { Source: 'Wedding venue profile' });
                                        }}
                                    >
                                        Download PDF
                                    </a>
                                )}
                            </div>
                        </div>
                    ))}
                    <div className={styles.showAllWrapper}>
                        <button className={cn('nx-button', styles.showAllButton)} onClick={() => setShowAllPlans(true)}>
                            Show All
                        </button>
                    </div>
                </div>
            </Section>
            <div className='VenuePage--additional-details-separator' />
        </>
    ) : null;
};

export default FloorPlans;
